import { Col, Row } from "antd";
import { CustomText, CustomTextArea, FormSelect } from "../../../../../components";

const ManageAllAsset = ({ formik }: any) => {
  return (
    <>
      <CustomText
        centered={true}
        strong={true}
        text='¿Deseas gestionar el estado del elemento de activos seleccionados?'
      />
      <br />
      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <FormSelect
            label="Estado del elemento"
            name="dependency"
            placeholder="Seleccione la dependencia"
            value={formik.values.status_id}
            options={[
              {
                name: 'Recibido',
                id: '15'
              },
              {
                name: 'Rechazado',
                id: '10'
              }
            ]}
            error={formik.errors.status_id}
            touched={formik.touched.status_id}
            onChange={(value) =>
              formik.setFieldValue('status_id', value)
            }
            onBlur={formik.handleBlur}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={24}>
          <CustomTextArea
            label="Observaciones"
            name="reason"
            placeholder="Observaciones"
            value={formik.values.reason}
            error={formik.errors.reason}
            touched={formik.touched.reason}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </Col>
      </Row>
    </>
  );
};

export default ManageAllAsset;
